@if (customHeaderTemplate) {
  <ng-container [ngTemplateOutlet]="customHeaderTemplate" />
} @else {
  <app-dialog-title>
    <ng-content></ng-content>
  </app-dialog-title>
}

<app-svg-icon
  name="cancel"
  class="app-dialog-close-button"
  (click)="closeDialog()"
/>
